import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const setDefaultLang = () => {
  const checkLang = localStorage.getItem('langDefault') || ""
  if (!checkLang) {
    fetch(`https://geolocation-db.com/json/`, {
      method: 'GET',
    }).then(async (response) => {
      let data = await response.json();
      // if(data?.country_code && !checkLang){
      //   const url = new URL(window.location.href);

      //   if(data?.country_code === 'VN' ){
      //       i18n.changeLanguage('vi')
      //       url.searchParams.set("lng", 'vi');
      //       window.history.replaceState({}, "", url);
      //     } else {
      //       i18n.changeLanguage('en')
      //       url.searchParams.set("lng", 'en');
      //       window.history.replaceState({}, "", url);
      //     }
      //   localStorage.setItem('langDefault', data?.country_code)
      // }
      if (data?.country_code) {

        if (data?.country_code === "VN") {
          i18n.changeLanguage("vi");
          window.history.replaceState({}, "", "/");
        } else {
          i18n.changeLanguage("en");
          window.history.replaceState({}, "", "/en");
        }
        localStorage.setItem("langDefault", data?.country_code);
      }

    }).catch(error => {
      // const url = new URL(window.location.href);
      // i18n.changeLanguage('vi')
      // url.searchParams.set("lng", 'vi');
      // window.history.replaceState({}, "", url);
      // i18n.changeLanguage("vi");
    })
  }
}
// const setDefaultLang = () => {
//   const check = localStorage.getItem("langDefault") || "";
//   console.log(check);
//   if (!check)
//     fetch(`https://geolocation-db.com/json/`, {
//       method: "GET",
//     })
//       .then(async (response) => {
//         let data = await response.json();
//         if (data?.country_code) {
//           if (data?.country_code === "VN") {
//             i18n.changeLanguage("vi");
//             window.history.replaceState({}, "", "/");
//           } else {
//             i18n.changeLanguage("en");
//             window.history.replaceState({}, "", "/en");
//           }
//           localStorage.setItem("langDefault", data?.country_code);
//         }
//       })
//       .catch((error) => {
//         i18n.changeLanguage("vi");
//       });
// };
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnNull: false,
    resources: {}, // Để trống resources hoặc bạn có thể import local JSON vào đây
    fallbackLng: 'vi',
    debug: true,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  })
  .then((res) => {
    setDefaultLang();
  });
// .then(() => {
//   const url = new URL(window.location.href);
//   if (url.searchParams.get("lng") == 'default') {
//     setDefaultLang()
//     return ;
//   }
//   if (!url.searchParams.get("lng") && !localStorage.getItem('langDefault')) {
//     setDefaultLang()
//   }
// });;

export default i18n;

